import {
  GoogleAuthProvider,
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile,
  updatePassword,
  connectAuthEmulator,
} from 'firebase/auth';
import APP from './app';
import { EMULATOR_CONFIG, USE_EMULATOR } from './config';

const AUTH = getAuth(APP);

if (USE_EMULATOR && EMULATOR_CONFIG.AUTH) {
  connectAuthEmulator(AUTH, EMULATOR_CONFIG.AUTH);
}

/**
 * Sign in with email and password
 * @param {string} email - Email
 * @param {string} password - Password
 * @returns {Promise<void>}
 */
export const signIn = async (email, password) => {
  await signInWithEmailAndPassword(AUTH, email, password);
};

/**
 * Sign up with email and password
 * @param {string} email - Email
 * @param {string} password - Password
 * @returns {Promise<void>}
 */
export const signUp = async (email, password) => {
  await createUserWithEmailAndPassword(AUTH, email, password);
};

/**
 * Sign in with Google
 * @returns {Promise<void>}
 */
export const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  await signInWithPopup(AUTH, provider);
};

/**
 * Update profile
 * @param {Object} profile - Profile
 * @returns {Promise<void>}
 */
export const _updateProfile = async profile => {
  await updateProfile(AUTH.currentUser, profile);
};

/**
 * Update user password
 * @param {string} password - Password
 * @returns {Promise<void>}
 */
export const _updateUserPassword = async password => {
  await updatePassword(AUTH.currentUser, password);
};

/**
 * Reload user
 * @returns {Promise<void>}
 */
export const _reload = async () => {
  await AUTH.currentUser.reload();
};

/**
 * Logout
 * @returns {Promise<void>}
 */
export const _logout = async () => {
  await AUTH.signOut();
};

/**
 * On auth state changed
 * @param {Function} callback - Callback
 * @returns {Promise<void>}
 */
export const _onAuthStateChanged = callback => {
  onAuthStateChanged(AUTH, callback);
};

export default AUTH;
